import React from 'react'
import styled, { keyframes } from 'styled-components'

/**
 * Spinning animation
 */
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

/**
 * Styled spinner container
 */
const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xxl};
`

/**
 * Styled spinner
 */
const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid ${props => props.theme.colors.border};
  border-top: 4px solid ${props => props.theme.colors.primary};
  border-radius: ${props => props.theme.borderRadius.full};
  animation: ${spin} 1s linear infinite;
`

/**
 * Loading spinner component
 * @returns Loading spinner
 */
function LoadingSpinner(): React.JSX.Element {
  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  )
}

export default LoadingSpinner
